import { ANIMATION_TYPES } from '@website-editor/context/NavigationPaneContext/NavigationPane.constants';
import { CUSTOM_PAGE_ACTIONS } from '@website-editor/customComponents/CustomComponents.constants';

export const GRAPHIC_ACCENT_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/graphicAccentSchemaV1_0_0.json' as const;
export const GRAPHIC_ACCENT_COMPONENT_TYPE = 'GraphicAccent' as const;

export const GRAPHIC_ACCENT_ACTIONS = {
  SELECT: 'graphic_accent_select',
} as const;

export const GRAPHIC_ACCENT_SCREENS = [GRAPHIC_ACCENT_ACTIONS.SELECT];

export const GRAPHIC_ACCENT_ANIMATION_CONFIG = {
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS]: [{ navigatedFrom: GRAPHIC_ACCENT_ACTIONS.SELECT, animationType: ANIMATION_TYPES.OVERLAY_VIEW }],
  [GRAPHIC_ACCENT_ACTIONS.SELECT]: [{ navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS, animationType: ANIMATION_TYPES.OVERLAY_VIEW }],
};
